import { render, staticRenderFns } from "./barPage.vue?vue&type=template&id=7ddc84a3"
import script from "./barPage.vue?vue&type=script&lang=js"
export * from "./barPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports